import {Component, Input} from "@angular/core";
import { VisualsService } from "app/core-ui/abstract/services/visuals.service";

  @Component({
    selector: "auditTrail",
    templateUrl: "auditTrail.component.html",
    styleUrls: ['./auditTrail.component.css']
  })
  export class AuditTrailComponent{
    public statusList  = [];
    public group = 'auditTrail';
    public visuals;
    
    @Input() userId: any;
    private _data;

    @Input()
    set list(value) {
      if(value === undefined){
        return
      }
      this._data = value;
      this._data.forEach((item,index) => {
        this._data[index].params = JSON.parse(item.params);
      });
    }
  
    get list() {
      return this._data;
    }
    
    constructor(public visualsService: VisualsService) {
      this.statusList = visualsService.getLkpFromStorageAsJSON(
        "LKP_REG_USER_S_STATUS",
        true
      );
      this.getVisuals();
  }
  public getVisuals() {
    this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
  }
  }
  